//热点聚焦
import React from 'react';
import './RelatedCases.scss';
let Swiper = window.Swiper
export class RelatedCases extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      navSwiper: '',

    }

  }
  componentDidMount() {
    this.setState({
      navSwiper: new Swiper('.'+this.props.id, {
        loop:true,
        speed:2500,
        slidesPerView: 'auto',
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
          waitForTransition: true,
        },
      })
    })
  }
  render() {
    return (
      <div className="related-cases">
        <div className="cases-title">
          <p>相关案例</p>
          <div></div>
        </div>
        <div className= {['swiper-container','swiper-xg',this.props.id].join(' ')} >
          <div className="swiper-wrapper">
            {
              this.props.caseList.map((item, index) => {
                return (
                  <div key={index} className="swiper-slide">
                    <img data-src={item.imgs} alt="" className="related-img swiper-lazy" />
                    <p>{item.name}</p>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    )
  }
}
